import { Injectable } from '@angular/core';

/**
 * Service used to load scripts dynamically
 */
@Injectable()
export class ScriptService {
    /**
     * Load the given script src/url if it hasn't already
     */
    public loadScript(scriptSrc: string): void {
        if (!scriptSrc) {
            return;
        }

        // Check if the script has already been loaded
        let isFound: boolean = false;
        const scripts: HTMLCollectionOf<HTMLScriptElement> = document.getElementsByTagName('script');

        for (let i: number = 0; i < scripts.length; i++) {
            const script: HTMLScriptElement = scripts[i];

            if (script.getAttribute('src') === scriptSrc) {
                isFound = true;
                break;
            }
        }

        if (!isFound) {
            // Load the script
            const node: HTMLScriptElement = document.createElement('script');
            node.src = scriptSrc;
            node.type = 'text/javascript';
            node.async = false;
            node.charset = 'utf-8';
            document.getElementsByTagName('head')[0].appendChild(node);
        }
    }
}
